import { createReducer } from '@reduxjs/toolkit';
import { Pharmacy } from 'lib/amwell/sdk/types';
import { RESET_AMWELL_ACTIVITY } from '../actions';
import * as actions from './actions';
import { SearchCriteria } from './types';

export type PharmaciesState = Readonly<{
  list: {
    data: Pharmacy[];
    lastSearchCriteria: SearchCriteria | null;
    loading: boolean;
    error: Error | null;
  };
  preferred: {
    data: Pharmacy | null;
    loading: boolean;
    preferredPharmacyWasUpdated: boolean;
    error: Error | null;
  };
}>;

export const pharmaciesInitialState: PharmaciesState = {
  list: {
    data: [],
    lastSearchCriteria: null,
    loading: false,
    error: null
  },
  preferred: {
    data: null,
    loading: false,
    preferredPharmacyWasUpdated: false,
    error: null
  }
};

export const pharmaciesReducer = createReducer(pharmaciesInitialState, {
  [actions.GET_ALL_PHARMACIES]: state => {
    state.list.loading = true;
    state.list.error = null;
  },
  [actions.GET_ALL_PHARMACIES_BY_INPUT]: state => {
    state.list.loading = true;
    state.list.error = null;
  },
  [actions.GET_ALL_PHARMACIES_FAIL]: (state, action) => {
    state.list.loading = false;
    state.list.error = action.error;
  },
  [actions.GET_ALL_PHARMACIES_BY_INPUT_FAIL]: (state, action) => {
    state.list.loading = false;
    state.list.error = action.error;
  },
  [actions.GET_ALL_PHARMACIES_SUCCESS]: (state, action) => {
    state.list.data = action.payload;
    state.list.loading = false;
  },
  [actions.GET_ALL_PHARMACIES_BY_INPUT_SUCCESS]: (state, action) => {
    state.list.data = action.payload;
    state.list.loading = false;
  },
  [actions.SEARCH_PHARMACIES]: (state, action) => {
    state.list.lastSearchCriteria = action.payload.request.data;
    state.list.loading = true;
    state.list.error = null;
  },
  [actions.SEARCH_PHARMACIES_FAIL]: (state, action) => {
    state.list.loading = false;
    state.list.error = action.error;
  },
  [actions.SEARCH_PHARMACIES_SUCCESS]: (state, action) => {
    state.list.data = action.payload;
    state.list.loading = false;
  },
  [actions.UPDATE_PREFERRED_PHARMACY]: state => {
    state.preferred.loading = true;
    state.preferred.error = null;
  },
  [actions.UPDATE_PREFERRED_PHARMACY_FAIL]: (state, action) => {
    state.preferred.loading = false;
    state.preferred.error = action.error;
  },
  [actions.UPDATE_PREFERRED_PHARMACY_SUCCESS]: (state, action) => {
    state.preferred.data = action.payload;
    state.preferred.loading = false;
    state.preferred.preferredPharmacyWasUpdated = true;
  },
  [actions.GET_PREFERRED_PHARMACY]: state => {
    state.preferred.loading = true;
    state.preferred.error = null;
  },
  [actions.GET_PREFERRED_PHARMACY_FAIL]: (state, action) => {
    state.preferred.loading = false;
    state.preferred.error = action.error;
  },
  [actions.GET_PREFERRED_PHARMACY_SUCCESS]: (state, action) => {
    state.preferred.data = action.payload;
    state.preferred.loading = false;
  },
  [RESET_AMWELL_ACTIVITY]: () => pharmaciesInitialState
});
